import templateUrl from "emun.cart/cart-item-quick-view-coloroptions.htm";

export default () => ({
  templateUrl
});
